import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetChallengeSummary = async function(compettionId, startDate, endDate) {
    let summary = {
        numberOfRecords: {
            healthData: 0,
            sleep: 0,
            water: 0,
            workout: 0,
            food: 0
        },
        memberNumbers: {
            male: 0,
            female: 0,
        },
        totalSummary: {
            totalWeightLoss: 0,
            totalWorkoutMins: 0,
            totalStep: 0,
            totalPBWF: 0,
        },
        agesOfUsers: {
            categories: ['0-14', '15-39', '40-49', '50-59', '60+'],
            male: [],
            female: []
        },
        recal: 1
    };
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');
         
        const result = await Promise.all([
            //0: steps
            queryThaisookViewBigQuery({
                info: 'get steps from workout',
                query: `
                    SELECT 
                        sum(steps) as totalStep 
                    FROM 
                        activity_view.workout A,
                        thaisook_view.competition_users as B 
                    WHERE 
                        A.uid = B.uid
                        and date(A.date) between '${startDate}' and '${endDate}'
                        and date(A.date) >= date(B.startWeightDate)
                        and competitionId='${compettionId}'
                `
            }),
    
            //1: weightLoss
            queryThaisookViewBigQuery({
                info: 'get weight loss',
                query2: `
                    SELECT 
                        sum(weightLoss) as totalWeightLoss 
                    FROM 
                        thaisook_view.competition_users 
                    WHERE 
                        competitionId='${compettionId}'
                    `,
                query: `
                    with data as (
                        SELECT 
                            HD.uid,
                            HD.date, 
                            HD.weight,
                            FIRST_VALUE(HD.weight) OVER(PARTITION BY HD.uid ORDER BY date) AS start_weight,
                            LAST_VALUE(HD.weight) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_weight,
                            ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY HD.date DESC) AS last_record
                        FROM 
                            thaisook_view.healthdata HD
                            join thaisook_view.competition_users G
                            on G.uid = HD.uid 
                        where 
                            HD.weight is not null
                            and G.competitionId = '${compettionId}'
                            and date(HD.date) between '${startDate}' and '${endDate}'
                            and date(HD.date) >= date(G.startWeightDate)
                            order by HD.date
                    )
                    , data2 as (
                        select * from data where last_record = 1
                    )
                    select sum(IF( (end_weight > start_weight), 0, (start_weight - end_weight) )) as totalWeightLoss from data2;
                `
            }),

                

            //2: get member counting
            queryThaisookViewBigQuery({
                info: 'get member counting',
                query:  `
                    SELECT 
                        count(case when gender='male' then 1 end) as male_cnt, 
                        count(case when gender='female' then 1 end) as female_cnt, 
                        count(1) as total_cnt 
                    FROM 
                        thaisook_view.users as A, 
                        thaisook_view.competition_users as B 
                    WHERE 
                        A.uid = B.uid 
                        and B.competitionId='${compettionId}'
                `
            }), 

            //3: get step from wellness - workout
            queryThaisookViewBigQuery({
                info: 'get step from wellness - workout',
                query:  
                `WITH data as (
                    SELECT 
                    B.gender as sex,
                    IF( B.birthdate is null, 0, 
                        DATETIME_DIFF(CURRENT_DATETIME, B.birthdate, YEAR )) as age
                    FROM 
                    bsp-kiosk.thaisook_view.competition_users A, 
                    bsp-kiosk.thaisook_view.users B 
                    where 
                    A.uid = B.uid
                    and A.competitionId='${compettionId}'
                )
                -- '0-14', '15-39', '40-49', '50-59', '60+'
                SELECT (CASE WHEN age < 15 then '0-14'
                            WHEN age < 40 then '15-39'
                            WHEN age < 50 then '40-49'
                            WHEN age < 60 THEN '50-59'
                            WHEN age >= 60 THEN '60+'
                        END) as agegrp, sex,
                        COUNT(*) as nt
                FROM data
                GROUP BY agegrp, sex
                ORDER BY sex, MIN(age);
                `
            }),

            //4: get number of records
            queryThaisookViewBigQuery({
                info: 'get number of records',
                query:  
                `with dataHealthdata as (
                    SELECT 
                        count(*) cnt,
                        'healthdata' title
                    FROM 
                        thaisook_view.healthdata HD
                        join thaisook_view.competition_users G
                        on G.uid = HD.uid 
                    where 
                        G.competitionId = '${compettionId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                        and date(HD.date) >= date(G.startWeightDate)
                ),
                dataSleep as (
                    SELECT 
                        count(*) cnt,
                        'sleep' title
                    FROM 
                        activity_view.sleep HD
                        join thaisook_view.competition_users G
                        on G.uid = HD.uid 
                    where 
                        G.competitionId = '${compettionId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                        and date(HD.date) >= date(G.startWeightDate)
                ),
                dataWorkout as (
                    SELECT 
                        count(*) cnt,
                        'workout' title
                    FROM 
                        activity_view.workout HD
                        join thaisook_view.competition_users G
                        on G.uid = HD.uid 
                    where 
                        G.competitionId = '${compettionId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                        and date(HD.date) >= date(G.startWeightDate)
                ),
                dataWater as (
                    SELECT 
                        count(*) cnt,
                        'water' title
                    FROM 
                        activity_view.water HD
                        join thaisook_view.competition_users G
                        on G.uid = HD.uid 
                    where 
                        G.competitionId = '${compettionId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                        and date(HD.date) >= date(G.startWeightDate)
                ),
                dataFood as (
                    SELECT 
                        count(*) cnt,
                        'food' title
                    FROM 
                    activity_view.food HD
                        join thaisook_view.competition_users G
                        on G.uid = HD.uid 
                    where 
                        G.competitionId = '${compettionId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                        and date(HD.date) >= date(G.startWeightDate)
                )
                select * from dataHealthdata
                union all 
                select * from dataSleep
                union all
                select * from dataWater
                union all
                select * from dataWorkout
                union all
                select * from dataFood;
                `
            })

        ]);
        
        const userStepsObj = JSON.parse(result[0].data);
        if( userStepsObj.length ){
            summary.totalSummary.totalStep = userStepsObj[0].totalStep;
        }
    
        const weightLossObj = JSON.parse(result[1].data);
        if( weightLossObj.length ){
            summary.totalSummary.totalWeightLoss = weightLossObj[0].totalWeightLoss;
        }
    
        const memberNumberObj = JSON.parse(result[2].data);
        if( memberNumberObj.length ){
            summary.memberNumbers.male = memberNumberObj[0].male_cnt;
            summary.memberNumbers.female = memberNumberObj[0].female_cnt;
        }
        
        const memberAgeOfUsersObj = JSON.parse(result[3].data);
        if( memberAgeOfUsersObj.length ){
            const memberAgeOfUsers = memberAgeOfUsersObj.reduce((tmp, doc) => {
                if( tmp[doc.agegrp] == undefined ){
                    tmp[doc.agegrp] = {
                        male: 0,
                        female: 0
                    };
                }
                tmp[doc.agegrp][doc.sex] = doc.nt;
                return tmp;
            }, {});
        
            for (let i = 0; i < summary.agesOfUsers.categories.length; i++) {
                const group = summary.agesOfUsers.categories[i];
                summary.agesOfUsers.male.push(memberAgeOfUsers[group] == undefined ? 0 : memberAgeOfUsers[group]['male']);
                summary.agesOfUsers.female.push(memberAgeOfUsers[group] == undefined ? 0 : memberAgeOfUsers[group]['female']);
            }
        }

        const numberOfRecordsObj = JSON.parse(result[4].data);
        if( numberOfRecordsObj.length ){
            for (let i = 0; i < numberOfRecordsObj.length; i++) {
                const item = numberOfRecordsObj[i];
                summary.numberOfRecords[item.title] = numberOfRecordsObj[i].cnt;    
            }
        }

        summary.totalSummary.totalWorkoutMins = summary.numberOfRecords.workout;
        summary.totalSummary.totalPBWF = summary.numberOfRecords.food;
    return summary;
};
export default bqGetChallengeSummary;
